import { useState, useRef, useEffect } from 'react';
import { ChevronRightIcon, CheckIcon } from './Icons';

export default function CustomSelect({
  value,
  onChange,
  options = [],
  placeholder = 'Select...',
  size = 'default',
  compact = false,
}) {
  const [open, setOpen] = useState(false);
  const [dropUp, setDropUp] = useState(false);
  const ref = useRef(null);
  const dropdownRef = useRef(null);

  const selected = options.find((o) => o.value === value);

  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    const handleEsc = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('mousedown', handleClick);
      document.removeEventListener('keydown', handleEsc);
    };
  }, [open]);

  useEffect(() => {
    if (open && ref.current) {
      const rect = ref.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setDropUp(spaceBelow < 200);
    }
  }, [open]);

  const handleSelect = (val) => {
    onChange(val);
    setOpen(false);
  };

  const sizeClass = size === 'sm' ? 'cs--sm' : size === 'xs' ? 'cs--xs' : '';
  const compactClass = compact ? 'cs--compact' : '';

  return (
    <div className={`cs ${sizeClass} ${compactClass}`} ref={ref}>
      <button
        type="button"
        className={`cs-trigger ${open ? 'cs-trigger--open' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpen(!open);
        }}
      >
        <span className={`cs-trigger-label ${!selected ? 'cs-trigger-placeholder' : ''}`}>
          {selected ? (
            <>
              {selected.icon || null}
              {selected.dot && <span className="cs-dot" style={{ background: selected.dot }} />}
              {selected.label}
            </>
          ) : placeholder}
        </span>
        <ChevronRightIcon size={size === 'xs' ? 10 : size === 'sm' ? 12 : 14} className={`cs-chevron ${open ? 'cs-chevron--open' : ''}`} />
      </button>

      {open && (
        <div className={`cs-dropdown ${dropUp ? 'cs-dropdown--up' : ''}`} ref={dropdownRef}>
          {options.map((opt) => (
            <button
              key={opt.value}
              type="button"
              className={`cs-option ${opt.value === value ? 'cs-option--selected' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(opt.value);
              }}
            >
              <span className="cs-option-content">
                {opt.icon || null}
                {opt.dot && <span className="cs-dot" style={{ background: opt.dot }} />}
                {opt.label}
              </span>
              {opt.value === value && <CheckIcon size={size === 'xs' ? 10 : 14} className="cs-check" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
